<template lang="html">
  <div>
    <input type="text" v-model="longueur" @change="setPrice()" placeholder="Longueur du chant (en mm)">
    <select v-model="chant" @change="setPrice()">
      <option :value="c.id" v-for="c in chants">{{c.name}}</option>
    </select>
  </div>
</template>

<script>
import {chants} from '../../assets/configuration.js'

export default {
  data () {
    return {
      chants,
      chant: 0,
      price: 0,
      longueur: null
    }
  },
  watch: {
    // longueur () {
    //   this.setPrice()
    // }
  },
  methods: {
    setPrice () {
      var p = this.longueur * this.chants[this.chant].price
      if (this.price !== p) {
        this.$store.commit('subPrice', this.price)
        this.$store.commit('addPrice', p)
        this.price = p
        this.setDevis()
      }
    },
    setDevis () {
      this.$store.commit('setDevis', {id: 2, set: {longueur: this.longueur, chant: this.chant}})
    }
  }
}
</script>

<style lang="css" scoped>
   select {
     padding: 0px 15px;
   }
</style>



// WEBPACK FOOTER //
// FormeBordure.vue?15308417